import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Accordion from '@/storybook/components/Accordion/Accordion';
import { type AIFilterChip } from '../AIFilterChips/AIFilterChips';
import CollapsibleFilterGroup from '../CollapsibleFilterGroup/CollapsibleFilterGroup';
import { TestIds } from './testIds';
import styles from './AIFilterContext.module.css';

export interface AIFilterContextProps {
  globalFilters: ReadonlyArray<AIFilterChip>;
  localFilters: ReadonlyArray<AIFilterChip>;
  defaultExpanded?: boolean;
}

const AIFilterContext: FC<AIFilterContextProps> = ({ globalFilters, localFilters, defaultExpanded = false }) => {
  const { t } = useTranslation();

  if (globalFilters.length === 0 && localFilters.length === 0) {
    return null;
  }

  return (
    <section
      className={styles.container}
      aria-label={t('components.aiChatDrawer.filterContext.ariaLabel')}
      data-testid={TestIds.container}
    >
      <Accordion
        className={styles.accordion}
        title={t('components.aiChatDrawer.filterContext.title')}
        size="S"
        dividerVariant="topWhenCollapsed"
        defaultExpanded={defaultExpanded}
        data-testid={TestIds.accordion}
      >
        <div className={styles.groups}>
          <CollapsibleFilterGroup
            label={t('components.aiChatDrawer.filterHeader.globalLabel')}
            filters={globalFilters}
            dataTestId={TestIds.global}
          />
          <CollapsibleFilterGroup
            label={t('components.aiChatDrawer.filterHeader.localLabel')}
            filters={localFilters}
            dataTestId={TestIds.local}
          />
        </div>
      </Accordion>
    </section>
  );
};

export default AIFilterContext;
